import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { AddliststaffassignmentComponent } from './add_staff_assignment_list/addstaffassignmentlist.component';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateDirective } from '../../../../components/Utilites/Directives/translate.directive';

@Component({
  selector: 'app-liststaffassignment',
  templateUrl: './staffassignmentlist.component.html',
  styleUrls: ['./staffassignmentlist.component.scss'],
  imports: [
    MatButtonModule,
    MatTableModule,
    CommonModule,
    AddliststaffassignmentComponent,
    MatMenuModule,
    TranslateDirective
  ],
})
export class ListstaffassignmentComponent {
  classId: string | null = null;
  userId: string | null = null;
  addCompoView: boolean = false;
  displayedColumns: string[] = [
    'title',
    'deadline',
    'status',
    'passPercent',
    'submission',
    'actions',
  ];
  isAdding = false;

  assignments = [
    {
      id: '1',
      classId: '1',
      title: 'Database Normalization Exercise',
      deadline: 'Dec 15, 2024',
      status: 'Ongoing',
      passPercent: null,
      submission: '22/30',
    },
    {
      id: '2',
      classId: '1',
      title: 'User Interface Redesign',
      deadline: 'Jan 10, 2025',
      status: 'In review',
      passPercent: 89,
      submission: '30/30',
    },
    {
      id: '3',
      classId: '1',
      title: 'API Integration Testing',
      deadline: 'Feb 20, 2025',
      status: 'Closed',
      passPercent: null,
      submission: '10/25',
    },
    {
      id: '4',
      classId: '2',
      title: 'Data Migration Strategy',
      deadline: 'Mar 5, 2025',
      status: 'Ongoing',
      passPercent: null,
      submission: '15/20',
    },
    {
      id: '5',
      classId: '3',
      title: 'Accessibility Compliance Review',
      deadline: 'Apr 12, 2025',
      status: 'In review',
      passPercent: 89,
      submission: '95%',
    },
    {
      id: '6',
      classId: '3',
      title: 'Performance Optimization Analysis',
      deadline: 'May 22, 2025',
      status: 'Closed',
      passPercent: null,
      submission: '30/30',
    },
    {
      id: '7',
      classId: '4',
      title: 'User Feedback Collection',
      deadline: 'Jun 15, 2025',
      status: 'Ongoing',
      passPercent: null,
      submission: '8/10',
    },
    {
      id: '8',
      classId: '4',
      title: 'Security Vulnerability Assessment',
      deadline: 'Jul 30, 2025',
      status: 'In review',
      passPercent: 89,
      submission: '92%',
    },
  ];
  filteredAssignments: any[] = [];
  addMode: boolean = false;
  editMode: boolean = false;
  selectedAssignment: any = null;

  constructor(private _router: Router, private router: ActivatedRoute) {}

  ngOnInit(): void {
    this.classId = this.router.snapshot?.paramMap.get('classId');
    this.userId = this.router.snapshot?.paramMap.get('staffId');
    if (this.classId) {
      this.filteredAssignments = this.assignments.filter(
        (a) => a.classId === this.classId
      );
    } else {
      this.filteredAssignments = [];
    }
  }

  goBack(): void {
    this._router.navigate(['/assignments']);
  }

  statusClass(status: string) {
    return {
      'status-ongoing': status === 'Ongoing',
      'status-closed': status === 'Closed',
      'status-inreview': status === 'In review',
    };
  }
  addAssignment(): void {
    this.addMode = true;
    this.editMode = false;
    this.selectedAssignment = null;
  }
  editAssignment(assignment: any): void {
    this.editMode = true;
    this.addMode = false;
    this.selectedAssignment = assignment;
  }

  onSaveAssignment(updated: any): void {
    if (this.editMode) {
      // update existing
      const index = this.assignments.findIndex(
        (a) => a.id === this.selectedAssignment.id
      );
      if (index !== -1)
        this.assignments[index] = { ...this.selectedAssignment, ...updated };
    } else {
      // add new
      const newId = (this.assignments.length + 1).toString();
      this.assignments.push({ id: newId, classId: this.classId, ...updated });
    }

    this.addMode = this.editMode = false;
    this.selectedAssignment = null;
  }

  onCloseForm(): void {
    this.addMode = this.editMode = false;
    this.selectedAssignment = null;
  }

  viewAssignmentsDetails(assignmentId: number) {
    this._router.navigate([
      `/assignments/staff/${this.userId}/${this.classId}/${assignmentId}`,
    ]);
  }
}
